"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
require("rxjs/add/observable/timer");
require("rxjs/add/observable/of");
require("rxjs/add/observable/throw");
require("rxjs/add/operator/multicast");
require("rxjs/add/operator/retryWhen");
require("rxjs/add/operator/scan");
require("rxjs/add/operator/do");
require("rxjs/add/operator/catch");
var connectedClient_1 = require("./connectedClient");
var stompWebSocketHandler_1 = require("./protocol/stomp/stompWebSocketHandler");
var DEFAULT_MAX_CONNECT_ATTEMPT = 10;
var DEFAULT_TTL_CONNECT_ATTEMPT = 1000;
// STOMP Client Class
//
// All STOMP protocol is exposed as methods of this class ('connect()',
// 'send()', etc.)
var Client = /** @class */ (function () {
    function Client(createWsConnection, options) {
        var _this = this;
        // [CONNECT Frame](http://stomp.github.com/stomp-specification-1.1.html#CONNECT_or_STOMP_Frame)
        //
        // Return an Observable containing the connectedClient
        this.connect = function (headers) {
            // create one and only one dedicated observable per destination
            if (!_this.observableConnection) {
                var multicastConnection = _this.__connect(headers)
                    .multicast(function () { return new ReplaySubject_1.ReplaySubject(1); });
                multicastConnection.connect();
                _this.observableConnection = multicastConnection.refCount();
            }
            return _this.observableConnection;
        };
        this.__connect = function (headers) {
            return _this.__initConnectedClient(headers).switchMap(function (connection) {
                _this.isConnected = true;
                return Observable_1.Observable.of(new connectedClient_1.ConnectedClient(connection));
            })
                .catch(function (error) {
                return Observable_1.Observable.throw(error);
            });
        };
        this.__initConnectedClient = function (headers) {
            // we initialize the connection
            return _this.stompWebSockerHandler.initConnection(headers)
                .retryWhen(function (attemps) { return attemps.scan(function (errorCount, err) {
                // we reinitialize the error count if we were previously connected
                if (_this.isConnected) {
                    _this.isConnected = false;
                    errorCount = 0;
                }
                if (_this.maxConnectAttempt !== -1 && errorCount >= _this.maxConnectAttempt) {
                    throw 'Attempted to connect ' + errorCount + ' failed.';
                }
                return errorCount + 1;
            }, 1)
                .do(function (errorCount) { return Observable_1.Observable.timer(errorCount * _this.ttlConnectAttempt); }); });
        };
        this.stompWebSockerHandler = stompWebSocketHandler_1.default(createWsConnection, options);
        this.maxConnectAttempt = options.maxConnectAttempt || DEFAULT_MAX_CONNECT_ATTEMPT;
        this.ttlConnectAttempt = options.ttlConnectAttempt || DEFAULT_TTL_CONNECT_ATTEMPT;
        this.isConnected = false;
    }
    return Client;
}());
exports.default = Client;
